import {useCardsTemplate} from 'Event/template/Cards'
import styled from 'styled-components'
import React from 'react'
import {useGuestVariables} from 'Event'
import Configurable from 'organization/Event/Configurable'
import TitleConfig from 'Event/template/Cards/Login/Title/TitleConfig'
import {Font, fontStyles, useLoadFont} from 'lib/FontSelect'

export default function Title() {
  const {
    login: {
      welcome: {text, font},
    },
  } = useCardsTemplate()
  const v = useGuestVariables()

  useLoadFont(font)

  return (
    <Configurable>
      <TitleConfig />
      <TitleBase aria-label="event login title">{v(text)}</TitleBase>
    </Configurable>
  )
}

export function TitleBase(props: {
  children: string | JSX.Element
  'aria-label'?: string
  className?: string
}) {
  const {
    login: {
      welcome: {color, fontSize, font},
    },
    textColor,
  } = useCardsTemplate()

  if (!props.children) {
    return null
  }

  return (
    <TitleText
      textColor={textColor}
      titleTextColor={color}
      fontSize={fontSize}
      font={font}
      aria-label={props['aria-label']}
      className={props.className}
    >
      {props.children}
    </TitleText>
  )
}

export const TitleText = styled.div<{
  textColor: string
  titleTextColor?: string | null
  fontSize: number
  font: Font | null
}>`
  ${(props) => fontStyles(props.font)}
  color: ${(props) =>
    props.titleTextColor ? props.titleTextColor : props.textColor} !important;
  font-size: ${(props) => props.fontSize}px;
  font-weight: 500;
  margin-bottom: ${(props) => props.theme.spacing[4]};
  text-align: left;
`
